<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditGateway"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="editEmailGateways"
          class="fixed h-full overflow-y-auto center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Edit Email Gateway</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>

          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>

          <div class="grid grid-cols-2 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Host</label>
              <input
                v-model="data.Host"
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Port</label>
              <input
                v-model="data.Port"
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Username</label>
              <input
                v-model="data.Username"
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Password</label>
              <input
                v-model="data.Password"
                type="password"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Sender</label>
              <input
                v-model="data.From"
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Receive Error</label>
              <input
                v-model="data.ReceiveError"
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Organization Link</label>
              <input
                v-model="data.OrganizationLink"
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Admin Link</label>
              <input
                v-model="data.AdminLink"
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Error Notification Email</label>
              <select
                @input="handleInput"
                v-model="ErrorNotification"
                name="ErrorNotification"
                id=""
                class="p-2 bg-gray-200 rounded-full w-full"
              >
                <option
                  v-for="template of emailTemplates"
                  :key="template.Id"
                  :value="template.Id"
                  :selected="ErrorNotification === template.TemplateName"
                >
                  {{ template.TemplateName }}
                </option>
              </select>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Welcome Email</label>
              <select
                @input="handleInput"
                v-model="WelcomeEmail"
                name="WelcomeEmail"
                id=""
                class="p-2 bg-gray-200 rounded-full w-full"
              >
                <option
                  v-for="template of emailTemplates"
                  :key="template.Id"
                  :value="template.Id"
                  :selected="WelcomeEmail"
                >
                  {{ template.TemplateName }}
                </option>
              </select>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Password Reset Email</label>
              <select
                @input="handleInput"
                v-model="PasswordReset"
                name="PasswordReset"
                id=""
                class="p-2 bg-gray-200 rounded-full w-full"
              >
                <option
                  v-for="template of emailTemplates"
                  :key="template.Id"
                  :value="template.Id"
                  :selected="PasswordReset"
                >
                  {{ template.TemplateName }}
                </option>
              </select>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Enrollment Successful Email</label>
              <select
                @input="handleInput"
                v-model="EnrollmentSuccessful"
                name="EnrollmentSuccessful"
                id=""
                class="p-2 bg-gray-200 rounded-full w-full"
              >
                <option
                  v-for="template of emailTemplates"
                  :key="template.Id"
                  :value="template.Id"
                  :selected="EnrollmentSuccessful"
                >
                  {{ template.TemplateName }}
                </option>
              </select>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Registration Email</label>
              <select
                @input="handleInput"
                v-model="EnrollmentRequest"
                name="EnrollmentRequest"
                id=""
                class="p-2 bg-gray-200 rounded-full w-full"
              >
                <option
                  v-for="template of emailTemplates"
                  :key="template.Id"
                  :value="template.Id"
                  :selected="EnrollmentRequest"
                >
                  {{ template.TemplateName }}
                </option>
              </select>
            </div>
          </div>
          <div class="grid grid-cols-2 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Timeoff Request Submitted</label>
              <select
                @input="handleInput"
                v-model="TimeoffRequestSubmitted"
                name="TimeoffRequestSubmitted"
                id=""
                class="p-2 bg-gray-200 rounded-full w-full"
              >
                <option
                  v-for="template of emailTemplates"
                  :key="template.Id"
                  :value="template.Id"
                  :selected="TimeoffRequestSubmitted"
                >
                  {{ template.TemplateName }}
                </option>
              </select>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Timeoff Awaiting Approval</label>
              <select
                @input="handleInput"
                v-model="TimeoffAwaitingApproval"
                name="TimeoffAwaitingApproval"
                id=""
                class="p-2 bg-gray-200 rounded-full w-full"
              >
                <option
                  v-for="template of emailTemplates"
                  :key="template.Id"
                  :value="template.Id"
                  :selected="TimeoffAwaitingApproval"
                >
                  {{ template.TemplateName }}
                </option>
              </select>
            </div>

            <div class="text-sm">
              <label class="block pb-1">Timeoff Request Approved</label>
              <select
                @input="handleInput"
                v-model="TimeoffRequestApproved"
                name="TimeoffRequestApproved"
                id=""
                class="p-2 bg-gray-200 rounded-full w-full"
              >
                <option
                  v-for="template of emailTemplates"
                  :key="template.Id"
                  :value="template.Id"
                  :selected="TimeoffAwaitingApproval"
                >
                  {{ template.TemplateName }}
                </option>
              </select>
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/components/loader/loader.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "AdminSetupEditGateway",
  props: ["showEditGateway", "data"],
  components: { Loader },
  data() {
    return {
      loading: false,
      edit_error: null,
      PasswordReset: null,
      emailTemplates: [],
      WelcomeEmail: null,
      EnrollmentSuccessful: null,
      EnrollmentRequest: null,
      selectedRegEmail: null,
      ErrorNotification: null,
      TimeoffRequestSubmitted: null,
      TimeoffAwaitingApproval: null,
      TimeoffRequestApproved: null,
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  created() {
    //console.log(this.data)
    this.getEmailTemplates();
    this.data = {
      ...this.data,
      PasswordReset: null,
      emailTemplates: [],
      WelcomeEmail: null,
      EnrollmentSuccessful: null,
      EnrollmentRequest: null,
      selectedRegEmail: null,
      ErrorNotification: null,
      TimeoffRequestSubmitted: null,
      TimeoffAwaitingApproval: null,
      TimeoffRequestApproved: null,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    editEmailGateways() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      this.data["Sender"] = this.data.From;

      axios
        .put(
          `setup/email/${this.$ApiVersion}/edit`,
          JSON.stringify(this.data),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$emit("closeOnSuccess", response.data.StatusMessage);
            } else {
              this.edit_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
          }
        );
    },
    handleInput(e) {
      const { name, value } = e.target;
      //console.log(name, value)
      this.data[name] = value;
    },
    getEmailTemplates() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      this.data = {
        ...this.data,
        PasswordReset: this.PasswordReset,
        WelcomeEmail: this.WelcomeEmail,
        EnrollmentSuccessful: this.EnrollmentSuccessful,
        EnrollmentRequest: this.EnrollmentRequest,
        ErrorNotification: this.ErrorNotification,
      };
      //console.log(this.data)
      axios
        .get(
          `setup/email/template/${this.$ApiVersion}/request`,

          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.emailTemplates = response.data.Data;
            } else {
              this.edit_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
